import Link from 'next/link';
import { useForm } from 'react-hook-form';
import InputField from '../Common/InputField';
import Button from '../Common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../../redux/Auth/authActions';
import { login } from '../../../redux/Auth/authSlice';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import Swal from 'sweetalert2';
import Logo from '../Logo';
import { forgotPassword } from '../../../redux/Auth/authCrud';
import { toast } from 'react-hot-toast';

function ForgotPassword() {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const router = useRouter();
  const [btnLoader, setBtnLoader] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm();

  // Swal.fire('Error!', auth.error, 'error');

  const onSubmit = (values) => {
    console.log('values', values);
    setBtnLoader(true);
    const forgotPasswordPayload = {
      email: values.email,
    };
    forgotPassword(forgotPasswordPayload)
      .then((res) => {
        const responseData = res.data;
        if (responseData.status === 'S') {
          toast.success(responseData.message, { duration: 8000 });
          router.push('/login');
        } else {
          setError('email', {
            type: 'custom',
            message: responseData.message,
          });
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setBtnLoader(false);
      });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      // className={Object.keys(errors).length ? "was-validated" : ""}
    >
      <div className="mb-3">
        <Logo />
      </div>
      <h1 className="h3 mb-3 fw-normal">Forgot Password</h1>
      <p>Enter your 1Link email to reset your password</p>
      <div className="mb-3">
        <InputField
          placeholder="Enter email"
          type="text"
          label="Email"
          name="email"
          register={register}
          validation={{
            required: true,
            minLength: '3',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'invalid email address',
            },
          }}
          errors={errors?.email}
        />
      </div>

      <Button className="w-100 btn-lg btn-primary" btntext="Reset Password" loading={btnLoader} />
    </form>
  );
}

export default ForgotPassword;
